import React, { ReactNode } from 'react';
import styled from 'styled-components';

import StarterLogo from 'assets/svg/trampolin-logo-white.svg';
import StarterLogoBlack from 'assets/svg/trampolin-logo.svg';

import { breakpoints, variables } from 'styles/variables';
import { Container } from 'components/container/Container';

import AniLink from 'gatsby-plugin-transition-link/AniLink';

interface HeaderProps {
  theme: string,
  children: ReactNode;
}

const HeaderRoot = styled.header`
  position: relative;
  display: block;
`;

const Content = styled.div`
  display: flex;
  align-items: center;

  padding: ${variables.gutter} 0;
`;

const Logo = styled(StarterLogo)`
  display: block;

  height: 46px;
  width: auto;

  @media (min-width: ${breakpoints.md}) {
    height: 46px;
  }
`;

const LogoBlack = styled(StarterLogoBlack)`
  display: block;

  height: 46px;
  width: auto;

  @media (min-width: ${breakpoints.md}) {
    height: 46px;
  }
`;

const Navigation = styled.div`
  display: flex;
  margin-left: auto;
`;

export const Header = ({ theme, children }: HeaderProps) => (
  <HeaderRoot>
    <Container>
      <Content>
        <AniLink paintDrip hex="#000" to="/">
          {theme === 'dark' ?  <Logo /> : <LogoBlack/>}
        </AniLink>

        <Navigation>{children}</Navigation>
      </Content>
    </Container>
  </HeaderRoot>
);
